import { useState } from "react";
import { IoMdEye, IoIosEyeOff } from "react-icons/io";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import api from "../../Api"

export default function Credentials() {
  const [isVisible, SetIsVisible] = useState(false);
  const [forgotPassword, SetForgotPassword] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      const response = await axios.post(
        api.login,
        { email, password },
        {
          headers: {
            api_key: api.key,
            authentication: api.authantication,
          },
        }
      );

      if (response.data.userData.accessToken) {
        // Store the access token (optional)
        localStorage.setItem("accessToken", response.data.userData.accessToken);

        // Navigate to /home
        navigate("/dashboard/testimonial");
      }
    } catch (error) {
      console.error("Error during login:", error);
      setErrorMessage("Something went wrong");
    }
  };

  return (
    <div className="space-y-6 w-full">
      <div className="space-y-2">
        <img src="/images/logo.svg" alt="logo" />
        <p className="text-secondary">
          {!forgotPassword
            ? " Hi Welcome to Minka Promotions Admin Console"
            : "Please enter the email that you created account"}
        </p>
      </div>

      <div className="space-y-4">
        <input
          placeholder="Email"
          type="text"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="border rounded p-2 px-4 w-full outline-none"
        />
        {!forgotPassword ? (
          <div className="space-y-4">
            <div className="border rounded w-full flex items-center px-4">
              <input
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                type={isVisible ? "text" : "password"}
                className=" p-2 pl-0 w-full outline-none"
              />
              <button
                onClick={() => SetIsVisible(!isVisible)}
                className="focus:outline-none"
              >
                {isVisible ? (
                  <IoIosEyeOff className="text-[24px]" />
                ) : (
                  <IoMdEye className="text-[24px]" />
                )}
              </button>
            </div>
            <button
              onClick={handleLogin}
              className="bg-primary w-full text-white p-2 px-4 rounded font-[600] duration-300 hover:bg-primary_dark"
            >
              Login
            </button>
            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <p
              onClick={() => SetForgotPassword(true)}
              className="text-secondary capitalize w-full text-center text-black/default font-[600] hover:cursor-pointer hover:text-primary"
            >
              Forgot Password
            </p>
          </div>
        ) : (
          <div className="space-y-2">
            <button
              onClick={() => SetIsVisible(true)}
              className="bg-primary w-full text-white p-2 px-4 rounded font-[600] duration-300 hover:bg-primary_dark"
            >
              Submit
            </button>
            <p
              onClick={() => SetForgotPassword(false)}
              className="text-secondary capitalize w-full text-center text-black/default hover:cursor-pointer text-primary"
            >
              Back to login
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
